exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".showsample{text-align:right}.showsample__btn{cursor:pointer;position:relative;color:#ed1e79;width:160px;margin:auto;display:block;font-size:12px;line-height:22px;min-width:161px;text-align:center}.showsample__btn .text:after{content:\"\";width:22px;height:22px;position:absolute;background:url(\"/static/img/common/arrow_right_pink.png\");background-size:100%;background-repeat:no-repeat;background-position:50%;top:0;right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3ee0163d","scoped":false,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/ShowSample.vue
// module id = zwV5
// module chunks = 0